/* talk·point — Kontakt-Hero: Chat-Pill öffnet den Theme-Chat-Drawer (#chat-drawer).
   Fallback: zum Formular scrollen. Section-scoped über das vorangehende Element. */
(function () {
  var sec = document.currentScript.previousElementSibling;
  while (sec && !(sec.classList && sec.classList.contains('tp-koh'))) {
    sec = sec.previousElementSibling;
  }
  if (!sec) return;

  function openWidget(e) {
    if (e && e.preventDefault) e.preventDefault();
    var drawer = document.getElementById('chat-drawer');
    if (drawer && typeof drawer.open === 'function') {
      drawer.open();
      return;
    }
    var form = document.getElementById('kontaktformular');
    if (form) form.scrollIntoView({ behavior: 'smooth' });
  }

  var btns = sec.querySelectorAll('[data-open-talki]');
  for (var i = 0; i < btns.length; i++) {
    btns[i].addEventListener('click', openWidget);
  }
})();
